<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import InputArea from "@/components/c-input-area";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import i18n from "../../../i18n";

//import { saleService } from "../../../services/saleservice/sale.service";
import { paymentService } from "../../../services/paymentservice/payment.service";


/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Property Change Payment Term",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
    InputArea
  },
  data() {
    return {
     
      discount: 0,
      loader: false,
      allData: {},
      reciever_id: 0,
      recievers: {},
      pay_date:0,
      paid_date: 0,
      pay_amount:0,
      pay_amount_or:0,
      total_pay:0,
      l_penalty:0,
      over_day: 0,
      penalty_fee: 0,
      pay_methods:{},
      pay_method_id: 0,
      postData:{},
      today_pay:'',
      sale_id: 0,
      notation: '',
      bank_accounts: {},
      bank_account_id: 0

    };
  },
  mounted() {
    this.loadData(this.$route.params.id);
    
  },

  methods:{
    loadData: function(id){
      paymentService.getPay(id).then(response => {
        this.allData = response.data;
        console.log(this.allData);

        
        this.sale_id = id;
        this.recievers = {'data': this.allData.recievers};
        this.pay_date = this.allData.pay_info.pay_date;
        this.pay_amount = this.allData.pay_info.integer_pay;
        this.pay_amount_or = this.allData.pay_info.integer_pay;
        this.total_pay = this.allData.pay_info.integer_pay;
        this.l_penalty = this.allData.penalty_fee;
        this.penalty_fee = this.allData.penalty_fee;
        this.discount = this.allData.pay_info.discount;
        this.over_day = this.allData.over_day;
        this.pay_methods = {'data': this.allData.pay_methods};
        this.pay_method_id = 1;
        this.paid_date = this.allData.today;
        this.bank_accounts = {'data': this.allData.bank_accounts};
        this.cal_total();
        
        

        this.loader = true;
      });
      
    },
    cal_total: function(){
      
      if(this.pay_amount == "")
        this.pay_amount = 0;
      if(this.penalty_fee == "")
        this.penalty_fee = 0;
      if(this.discount == "")
        this.discount = 0;
        
      this.total_pay = parseFloat(this.pay_amount) + parseFloat(this.penalty_fee) - parseFloat(this.discount);
      
    },
    onBack: function(){
      this.$router.push(this.$route.query.redirectFrom || {
        name: "payment-list",
        params: {"id":this.sale_id}
      });
    },
    onSave(){
      if(this.allData.pay_info.integer_pay > 0){
        if( this.pay_amount_or >= this.pay_amount){

// Start =========

        this.$swal.fire({
          title: i18n.t('general.confirm-save.title'),
          text: i18n.t('general.confirm-save.message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.confirm-save.yes'),
          cancelButtonText: i18n.t('general.confirm-save.no')
        }).then(result => {
          if (result.value) {

          // start save ==================
            this.postData = {
              "schedule_id" : this.allData.pay_info.id,
              "paid" : this.pay_amount,
              "Penalty" : this.penalty_fee,
              "Payment_method_id" : this.pay_method_id,
              "Received_by_user_id" : this.reciever_id,
              "Pay_date" : this.paid_date,
              "notation" : this.notation,
              "bank_account_id": this.bank_account_id,
              "discount": this.discount
            };

            // console.log(JSON.stringify(this.postData));
            paymentService.addPay(this.postData).then(response => {
              if(response.status == 200) {
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#34c38f",
                  // cancelButtonColor: "#f46a6a",
                  confirmButtonText: i18n.t('general.ok'),
                  // cancelButtonText: i18n.t('general.success.no')
                }).then(result => {
                  if (result.value) {
                    this.onBack();
                  } else {
                    this.onBack();
                  }
                });
              }
            });

          // End save ==================

          }
        });

// End ===========





          
        }else{
          this.$swal.fire({
          title: i18n.t('general.success.title'),
          text: i18n.t('payment.pay_much_than_need'),
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#34c38f",
          // cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          // cancelButtonText: i18n.t('general.success.no')
          }).then(result => {
              if (result.value) {
                //this.onBack();
              } else {
                //this.onBack();
              }
          });
        }
        
      }else{
        this.$swal.fire({
          title: i18n.t('general.success.title'),
          text: i18n.t('payment.nothing-to-pay'),
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#34c38f",
          // cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          // cancelButtonText: i18n.t('general.success.no')
        }).then(result => {
              if (result.value) {
                //this.onBack();
              } else {
                //this.onBack();
              }
            });
      }
      
    },
    formatCurrency(value) {
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    }

  }
};
</script>

<template>
  <Layout>
    <PageHeader :items="['']" :title="$t('property.payment') + ' ' + $t('property.text')" />
    <Loading :loaded="loader"/>
    <b-form v-show="loader" @submit.prevent="submitSave" class="row">
      
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              
              <div class="col-md-12">
                 <Input 
                    :type="'date'"
                    :disabled="true"
                    :id="'pay_date'"
                    v-model="pay_date"
                    :label="'payment.pay_date'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'over_day'"
                    v-model="over_day"
                    :disabled="true"
                    :last="'ថ្ងៃ'"
                    :label="'payment.over_day'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'l_penalty'"
                    :disabled="true"
                    v-model="l_penalty"
                    :last="'USD'"
                    :label="'payment.penalty_fee'"  />
              </div>
              <div class="col-md-4">
                 <Input 
                    :type="'number'"
                    :id="'pay_amount'"
                    v-model="pay_amount"
                    :last="'USD'"
                    @leave="cal_total()"
                    :label="'payment.pay_amount'"  />
              </div>
              <div class="col-md-4">
                 <Input 
                    :type="'number'"
                    :id="'penalty_fee'"
                    v-model="penalty_fee"
                    :last="'USD'"
                    @leave="cal_total()"
                    :label="'payment.penalty_fee'"  />
              </div>
              <div class="col-md-4">
                 <Input 
                    :type="'number'"
                    :id="'discount'"
                    v-model="discount"
                    :last="'USD'"
                    @leave="cal_total()"
                    :label="'general.discount'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'total_pay'"
                    :disabled="true"
                    v-model="total_pay"
                    :last="'USD'"
                    :label="'payment.total_pay'"  />
              </div>
              <div class="col-md-6">
                 <Select 
                    :id="'id'"
                    :text="'label'"
                    :required="true"
                    v-model="pay_method_id"
                    :list="pay_methods"
                    :label="'payment.pay_method'"  />
              </div>
              <div class="col-md-6">
                 <Select 
                    :id="'id'"
                    :text="'label'"
                    :required="true"
                    v-model="bank_account_id"
                    :list="bank_accounts"
                    :label="'payment.bank_account'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'date'"
                    :id="'start_date'"
                    v-model="paid_date"
                    :label="'payment.paid_date'"  />
              </div>
              <div class="col-md-12">
                 <InputArea 
                    :type="'text'"
                    :id="'notation'"
                    v-model="notation"
                    :label="'payment.notation'"  />
              </div>
            </div>

          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="onBack()"
                        v-bind:title="$t('general.back')"  />
              </div>
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="onSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.pay')"  />
              </div>
            </div>

          </div>
        </div>
      </div>
    </b-form>
  </Layout>
</template>